import { axiosWrapper } from "../../axiosWrapper";
// import { IModifiedUpdateQuotePayload, IUpdateQuotePayload } from "../../pages/Quotation/UpdateQuotation/UpdateQuotation.types";
// import { IQuotePayload } from "../../pages/Quotation/CreateQuotation/CreateQuotation.types"
import { ISearchFor } from "../../pages/Quotation/Common/Interfaces/ISearchFor";
import { ISearchProductPayload } from "../../pages/Quotation/Components/AddItemPanelComponent/AddItemPanelComponent.types";
import { IDiscountSummaryPayload } from "../../pages/Quotation/QuotationDetail/QuotationDetail.types";
import { IProductSearchRequest, IApiResponse, IProductSearchResponse } from "../../pages/Quotation/Components/AddItemPanelComponent/ProductSearch.types";
import { FeatureFlags } from "../../config";
import { ActivityTimingTracker } from "../../Utils/ActivityTimingTracker";
export class QuotationDetailService {
    public static async getQuotationDetail(quoteSearch: ISearchFor) {
        const startTime = ActivityTimingTracker.startActivity('GetQuotationDetail');
        try {
            const response = await axiosWrapper.Get(`Quotations/Detail/${quoteSearch.searchText}/${quoteSearch.partitionKey}`);
            ActivityTimingTracker.endActivity('GetQuotationDetail', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('GetQuotationDetail', startTime);
            throw error;
        }
    }

    public static async getAvailableInventory(itemId: string) {
        const startTime = ActivityTimingTracker.startActivity('InventoryCheck');
        try {
            const response = await axiosWrapper.Get(`Inventory/CheckInventoryAvailability/${itemId}/nl`);
            ActivityTimingTracker.endActivity('InventoryCheck', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('InventoryCheck', startTime);
            throw error;
        }
    }

    public static async getAvailableInventoryAsList(ItemDetailEntity: {}) {
        const startTime = ActivityTimingTracker.startActivity('InventoryListUpdate');
        try {
            const response = await axiosWrapper.Post(`Inventory/UpdateInventoryAvailability/${ItemDetailEntity}`);
            ActivityTimingTracker.endActivity('InventoryListUpdate', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('InventoryListUpdate', startTime);
            throw error;
        }
    }

    public static async getAvailableInventoryByQuoteNum(QuotationNum: string) {
        const startTime = ActivityTimingTracker.startActivity('InventoryByQuoteUpdate');
        try {
            const response = await axiosWrapper.Post(`Inventory/UpdateInventoryAvailability/${QuotationNum}`);
            ActivityTimingTracker.endActivity('InventoryByQuoteUpdate', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('InventoryByQuoteUpdate', startTime);
            throw error;
        }
    }

    public static async getCustomerData(AccountNum: string) {
        const startTime = ActivityTimingTracker.startActivity('GetCustomerData');
        try {
            const response = await axiosWrapper.Get(`Quotations/GetCustomerData/${AccountNum}`);
            ActivityTimingTracker.endActivity('GetCustomerData', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('GetCustomerData', startTime);
            throw error;
        }
    }

    
    public static async getSkuDetail(itemId: string, market: string) {
        const startTime = ActivityTimingTracker.startActivity('GetSkuDetail');
        try {
            const response = await axiosWrapper.Get(`BigCat/GetProductPSAData/${itemId}/${market}`);
            ActivityTimingTracker.endActivity('GetSkuDetail', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('GetSkuDetail', startTime);
            throw error;
        }
    }
    
    public static async getSearchedSkuDetail(itemId: string, market: string) {
        const startTime = ActivityTimingTracker.startActivity('GetSearchedSkuDetail');
        try {
            const response = await axiosWrapper.Get(`BigCat/GetProductSkuAvailabilityData/${itemId}/${market}`);
            ActivityTimingTracker.endActivity('GetSearchedSkuDetail', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('GetSearchedSkuDetail', startTime);
            throw error;
        }
    }

    public static async getSelectedBundleDetails(itemId: string, bigId: string, market: string) {
        const startTime = ActivityTimingTracker.startActivity('BundleSelection');
        try {
            const response = await axiosWrapper.Get(`BigCat/SpecificBundleProductPSAData/${itemId}/${bigId}/${market}`);
            ActivityTimingTracker.endActivity('BundleSelection', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('BundleSelection', startTime);
            throw error;
        }
    }

    public static async getSearchedProductDetails(searchProductPayload: ISearchProductPayload) {
        const startTime = ActivityTimingTracker.startActivity('SearchProductDetails');
        try {
            const response = await axiosWrapper.Post(`BigCat/ProductSkuAvailability`, searchProductPayload);
            ActivityTimingTracker.endActivity('SearchProductDetails', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('SearchProductDetails', startTime);
            throw error;
        }
    }
      public static async getDetailsOfSelectedBundle(searchBundlePayload: ISearchProductPayload) {
        const startTime = ActivityTimingTracker.startActivity('BundleDetailsRetrieval');
        try {
            const response = await axiosWrapper.Post(`BigCat/SpecificBundle`, searchBundlePayload);
            ActivityTimingTracker.endActivity('BundleDetailsRetrieval', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('BundleDetailsRetrieval', startTime);
            throw error;
        }
    }
    
    public static async getDiscountSummary(discountPayload: IDiscountSummaryPayload) {
        const startTime = ActivityTimingTracker.startActivity('GetDiscountSummary');
        try {
            const response = await axiosWrapper.Get(`Quotations/DiscountSummary/${discountPayload.quoteId}/${discountPayload.partitionKey}`);
            ActivityTimingTracker.endActivity('GetDiscountSummary', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('GetDiscountSummary', startTime);
            throw error;
        }
    }    // Enhanced Product Search method - Enter key search (partial search)
    // Calls BigCat/ProductSearch endpoint for search results dropdown
    public static async searchProducts(searchRequest: IProductSearchRequest) {
        console.log("QuotationDetailService.searchProducts called with:", searchRequest);
        
        // Check if Product Search feature is enabled
        if (!FeatureFlags.enableProductSearch) {
            console.log("Feature flag disabled, returning mock response");
            // Return mock axios response when feature is disabled
            return {
                data: {
                    data: {
                        searchResults: [],
                        totalResults: 0,
                        searchTerm: searchRequest.searchTerm,
                        searchDuration: "0ms"
                    },
                    success: false,
                    message: "Product Search feature is currently disabled"
                },
                status: 200,
                statusText: 'OK'
            };
        }
        
        console.log("Feature flag enabled, calling BigCat/ProductSearch endpoint");
        // Feature is enabled, proceed with search using ProductSearch endpoint with timing tracking
        const startTime = ActivityTimingTracker.startActivity('ProductSearch');
        try {
            console.log("About to make POST request to BigCat/ProductSearch with payload:", searchRequest);
            const result = await axiosWrapper.Post(`BigCat/ProductSearch`, searchRequest);
            console.log("POST request completed, result:", result);
            ActivityTimingTracker.endActivity('ProductSearch', startTime);
            return result;
        } catch (error) {
            console.error("Error in axiosWrapper.Post call:", error);
            ActivityTimingTracker.endActivity('ProductSearch', startTime);
            throw error;
        }
    }

    // Search Icon functionality - Search icon click (direct product lookup) 
    // Calls BigCat/ProductSkuAvailability endpoint for direct product details
    public static async searchProductsIcon(searchProductPayload: ISearchProductPayload) {
        // Search icon functionality - always enabled (normal existing functionality)
        const startTime = ActivityTimingTracker.startActivity('SearchProductsIcon');
        try {
            const response = await axiosWrapper.Post(`BigCat/ProductSkuAvailability`, searchProductPayload);
            ActivityTimingTracker.endActivity('SearchProductsIcon', startTime);
            return response;
        } catch (error) {
            ActivityTimingTracker.endActivity('SearchProductsIcon', startTime);
            throw error;
        }
    }

    // public static async submitCreateQuotation(createQuote: IQuotePayload) {
    //     return await axiosWrapper.Post('Quotations/QuoteCreation/', createQuote);
    // }

    // public static async updateQuotation(quoteId: string, updateType: string, updateQuote: IUpdateQuotePayload | IModifiedUpdateQuotePayload) {
    //     // const quotePayload = {
    //     //     quoteHeader: {
    //     //         ...updateQuote.quoteHeader,
    //     //         contact: '',
    //     //     },
    //     //     quoteLineItems: {
    //     //         ...updateQuote.quoteLineItems
    //     //     }    //     // };
    //     return await axiosWrapper.Patch(`Quotations/QuoteUpdate/${quoteId}/${updateType}`, updateQuote);
    // }
}